import { Injectable, NgZone } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { RespuestaValidaPago } from 'src/app/global/enums/respuesta-valida-pago.enum';
import { ConfiguracionProducto } from 'src/app/global/interfaces/configuracion-producto';
import { SeleccionProductoRequest } from 'src/app/global/interfaces/seleccion-producto.request';
import { SeleccionProductoResponse } from 'src/app/global/interfaces/seleccion-producto.response';
import { LocalStorageService } from 'src/app/global/services/localstorage.service';
import { ProductosService } from 'src/app/global/services/productos.service';
import { Product } from 'src/app/view-model/components/shopping-cart/product';
import { ProductBuilder } from 'src/app/view-model/components/shopping-cart/product-builder';
import { CarroComprasService } from 'src/app/view-model/services/carro-compras.service';
import { DialogService } from 'src/app/view-model/services/dialog.service';
import { vmProductosService } from 'src/app/view-model/services/productos.service';

@Injectable()
export class ProductosVM extends vmProductosService {

  productos: Product[] = [];

  constructor(
    private productosProv: ProductosService,
    private carroService: CarroComprasService,
    private dialogService: DialogService,
    private ngZone: NgZone,
    private localStorageService: LocalStorageService
  ) {
    super();
  }

  registraSeleccionProductoActual(): Observable<unknown> {
    const product = this.carroService.getCurrentProduct();
    if (!product) {
      throw Error('No products found');
    }
    const productBuilder = new ProductBuilder();
    const seleccionProductos = productBuilder.toSeleccionProductoRequest(this.carroService.products);
    return this.registraSeleccionProducto(seleccionProductos);
  }

  cargaSeleccionActualEnCarro(): Observable<Product[]> {
    try {
      return this.productosProv.obtenerSeleccionProductos().pipe(
        map((response: SeleccionProductoResponse) => {

          const products = this.productFromSelectionProductResponse(response);
          this.cargarEnCarro(products);
          return products;
        }),

        catchError(() => [])
      );
    } catch (exception) {
      this.validarSolicitudVacia([]);
      return of([]);
    }
  }

  cargarEnCarro(products: Product[]) {
    this.carroService.products = products;
    this.productos = products;
    this.carroService.carroCompraVacio = true;
    if (products.length > 0) {
      this.carroService.changeRetoma(false);
      this.showCarroByRes();
    }
  }

  private showCarroByRes() {
    if (window.innerWidth < 1200) {
      this.carroService.hide();
    } else {
      this.carroService.show();
    }
  }

  obtieneSeleccionProducto(): Observable<Product[]> {
    try {
      return this.productosProv.obtenerSeleccionProductos().pipe(
        map((response: SeleccionProductoResponse) => {

          const products = this.productFromSelectionProductResponse(response);
          return products;
        }),

        catchError(() => [])
      );
    } catch (exception) {
      return of([]);
    }
  }

  private productFromSelectionProductResponse(response: SeleccionProductoResponse) {
    const productBuilder = new ProductBuilder();
    return productBuilder.fromSeleccionProductoResponse(response);
  }

  validarSolicitudVacia(products: Product[]): void {
    if (products.length === 0) {
      this.dialogService.openSolicitudVacia();
    } else {
      this.carroService.products = [];
      this.carroService.products.push(...products);
    }
  }

  existenProductosEnCarro(): number {
    return this.carroService.products.length;
  }

  registraSeleccionProducto(productos: SeleccionProductoRequest[]): Observable<any> {

    return this.productosProv.registraSeleccionProducto(productos)
      .pipe(map(this.registraProductoOK), catchError(this.error));
  }

  async validaPagoProducto(): Promise<any> {

    // const product = this.carroService.getCurrentProduct();
    // const data = {
    //   id: product.codigoProducto,
    //   tipoProducto: product.tipoProducto
    // };

    const data = this.arm_bodyPago();

    return this.productosProv.validaPagoProducto(data.producto)
      .pipe(map(this.validaPagoProductoOK), catchError(this.error)).toPromise();
  }

  private validaPagoProductoOK(resp) {
    if (resp.indicador) {
      if (resp.indicador === RespuestaValidaPago.ERROR_PRODUCTO_NO_ACEPTADO) {
        return RespuestaValidaPago.CONTINUAR_RESUMEN;
      } else if (resp.indicador === 'ERROR_PRODUCTO_FECHA_AGENDAMIENTO_VENCIDA') {
        // dialogo
        // this.dialogService.openFechaVencida();
        return RespuestaValidaPago.AGENDAR_FECHA;
      } else {
        return RespuestaValidaPago.AGENDAR_FECHA;
      }
    }

    if (resp.data) {
      return RespuestaValidaPago.CONTINUAR_RESUMEN;
    } else {
      return RespuestaValidaPago.URL_PAGO;
    }
  }

  private arm_bodyPago() {
    const product = this.carroService.getCurrentProduct();
    let codigoDescuento = this.carroService.getCodigoDescuento();
    if (codigoDescuento == null) {
      const dataPaso3 = this.localStorageService.getPaso3();
      if (dataPaso3.codigoDescuento) {
        codigoDescuento = dataPaso3.codigoDescuento.codigo;
      }
    }
    return {
      producto:{
        id: product.codigoProducto,
        tipoProducto: product.tipoProducto
      },
      codigoDescuento : codigoDescuento
    };
  }

  async obtenerUrlPago(): Promise<any> {
    const data = this.arm_bodyPago();
    return this.productosProv.obtenerUrlPago(data)
      .pipe(map(this.obtenerUrlPagoOK), catchError(this.error)).toPromise();
  }

  postConfiguracionProducto(data: any): Observable<any> {
    return this.productosProv.postConfiguracionProducto(data)
      .pipe(map(this.configuracionProductoPostOK), catchError(this.error));
  }

  obtenerConfiguracionProducto(): Observable<ConfiguracionProducto> {
    return this.productosProv.obtenerConfiguracionProducto()
      .pipe(map(this.obtenerConfiguracionProductoOK), catchError(this.error));
  }

  resumenPago(): Observable<any>{
    return this.productosProv.obtenerResumenPago();
  }

  validaPagoProductoProactivo(run: number): Observable<any>{
    return this.productosProv.validaPagoProductoEjecutivo(run);
  }

  obtenerValorUF(): Observable<any>{
    return this.productosProv.obtenerValorUF();
  }

  obtenerValoresMCC(): Observable<any>{
    return this.productosProv.obtenerValoresMCC();
  }

  validarDescuento(descuento : String) : Observable<any>{
    return this.productosProv.validarDescuento(descuento);
  }

  private obtenerConfiguracionProductoOK(resp) {
    return resp;
  }

  private configuracionProductoPostOK(resp) {
    return resp;
  }

  private obtenerUrlPagoOK = (resp) => resp.data;

  private registraProductoOK(resp) {
    return resp;
  }

  private error(error) {
    return throwError(error);
  }
}
